import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

// Import theme module
import COLORS from '../../themes/Colors'
import { px2Rem } from '../../themes/Mixins'
import { ZIndex } from '../../themes/Metrics'

// Defined component Button Nav
const ButtonNav = ({ customStyle, onClick, type, responsive }) => {
  return (
    <Link
      style={customStyle}
      onClick={onClick}
      type={type}
      responsive={responsive}
    />
  )
}

// Defined styled component for Button Nav
const Link = styled.a`
  position: absolute;
  z-index: ${ZIndex.large};
  cursor: pointer;
  border-color: ${COLORS.darkWhite};
  border-style: solid;
  transform: rotate(-45deg) skew(-13deg, -13deg);
  width: ${px2Rem(30)};
  height: ${px2Rem(30)};

  ${props => props.responsive}

  ${props => props.type === 'prev' && css`
    border-width: ${px2Rem(4)} 0 0 ${px2Rem(4)};
    left: 5%;
  `};

  ${props => props.type === 'next' && css`
    border-width: 0 ${px2Rem(4)} ${px2Rem(4)} 0;
    right: 5%;
  `};
`

ButtonNav.propTypes = {
  type: PropTypes.oneOf(['prev', 'next']),
  onClick: PropTypes.func
}

ButtonNav.defaultProps = {
  type: 'prev'
}

export default ButtonNav



// WEBPACK FOOTER //
// ./src/components/common/ButtonNav.js